import type { ReactElement } from "react";
import ReactDiffViewer, { DiffMethod } from "react-diff-viewer-continued";

interface DocDiffViewerProps {
	oldContent: string;
	newContent: string;
	oldTitle: string;
	newTitle: string;
}

const styles = {
	variables: {
		light: {
			diffViewerBackground: "#ffffff",
			addedBackground: "#e6f0fb",
			addedColor: "#1f2328",
			removedBackground: "#fff0f0",
			removedColor: "#1f2328",
			wordAddedBackground: "#cee1f8",
			wordRemovedBackground: "#ffd7d7",
			addedGutterBackground: "#cee1f8",
			removedGutterBackground: "#ffd7d7",
			gutterBackground: "#f6f8fa",
			gutterBackgroundDark: "#f6f8fa",
			codeFoldBackground: "#f6f8fa",
			codeFoldGutterBackground: "#f6f8fa",
			codeFoldContentColor: "#bcbdbf",
			emptyLineBackground: "#f6f8fa",
		},
	},
	contentText: {
		fontFamily: "inherit",
		fontSize: "14px",
		lineHeight: "1.6",
		whiteSpace: "pre-wrap" as const,
		wordBreak: "break-word" as const,
	},
	line: {
		padding: "2px 10px",
	},
	gutter: {
		minWidth: "30px",
		padding: "0 8px",
	},
	titleBlock: {
		padding: "8px 12px",
		fontSize: "12px",
		fontWeight: 500,
		color: "#626569",
		background: "#f6f8fa",
		borderBottom: "1px solid #ededee",
	},
};

export function DocDiffViewer({
	oldContent,
	newContent,
	oldTitle,
	newTitle,
}: DocDiffViewerProps): ReactElement {
	return (
		<div className="border-line-subtle overflow-hidden rounded-lg border">
			<ReactDiffViewer
				oldValue={oldContent}
				newValue={newContent}
				splitView={true}
				compareMethod={DiffMethod.WORDS}
				showDiffOnly={false}
				leftTitle={oldTitle}
				rightTitle={newTitle}
				styles={styles}
				hideLineNumbers
			/>
		</div>
	);
}
